export default function roundCoord (c, precision) {
  return [
    Math.round(c[0] / precision) * precision,
    Math.round(c[1] / precision) * precision
  ]
}
